import * as property from './property'

export default { property }
